import React, { useCallback } from 'react'
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import List from '@material-ui/core/List';
import makeStyles from '@material-ui/core/styles/makeStyles';
import LogoComponent from './LogoComponent';
import CloseIcon from '@material-ui/icons/Close';
import SideMenuItemComponent from './SideMenuItemComponent';
import { useSelector } from 'react-redux';
import SocialsGroupComponent from './SocialsGroupComponent';

const useStyles = makeStyles((theme) => ({
    paper: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        background: theme.palette.secondary.main,
        overflowX: 'hidden',
        height: '100%',
        maxHeight: '100vh',
        top: 0,
        bottom: 0,
        border: 'none',
    },
    mainContainer: {
        marginTop: 20,
    },
    list: {
        width: 320,
    },
    listCont: {
        marginTop: 20,
        marginLeft: 60,
        position: 'relative',
        [theme.breakpoints.down('xs')]: {
            marginLeft: 20,
            display: 'flex',
            justifyContent: 'center',
        },
    },

    lang: {
        paddingTop: 32,
    }
}))

const SideMenuComponent = ({ open, handleClose = () => { }, onOpen = () => { } }) => {
    const classes = useStyles();
    const side_menu = useSelector(state => state.ContainerReducer.menu?.side_menu);
    const onClose = useCallback(() => {
        document.querySelector('body').style.overflow = 'auto'
        handleClose()
    }, [handleClose])
    return (
        <SwipeableDrawer
            anchor='left'
            open={open}
            hysteresis={0.4}
            onClose={onClose}
            onOpen={onClose}
            classes={{
                paper: classes.paper
            }}
        >
            <Box>
                <Container className={classes.mainContainer}>
                    <LogoComponent
                        Icon={CloseIcon}
                        onClick={onClose}
                        end
                    />
                    <Box className={classes.listCont}>
                        <List className={classes.list}>
                            {side_menu?.length
                                ? side_menu.map((item) =>
                                    <SideMenuItemComponent
                                        handleClose={onClose}
                                        key={item.id}
                                        title={item.name}
                                        items={item.children}
                                        externalLink={item.external_link}
                                        pageLink={item.page_link}
                                        slug={item.slug}
                                    />
                                )
                                : ''}
                        </List>
                    </Box>
                </Container>
            </Box>
            <Box display='flex' justifyContent='center' mb='20px' zIndex='3'>
                <Box mt='10px'>
                    <SocialsGroupComponent primary />
                </Box>
            </Box>
        </SwipeableDrawer>
    )
}


export default React.memo(SideMenuComponent);